/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./CustomPlainCardTile.css";
import { themes, fonts } from "../../themes/themes";
interface ICustomEditCardProps {
  card_title?: string;
  card_subtitle?: string;
  card_height?: string;
  card_width?: string;
  title_color?: any;
  onClick?: () => void;
}

const CustomEditCard: React.FC<
  React.PropsWithChildren<ICustomEditCardProps>
> = ({
  children,
  card_title,
  card_height,
  card_width = "auto",
  card_subtitle,
  title_color,
}) => {
  return (
    <Box
      className="customPlainCard"
      style={{
        maxHeight: card_height,
        height: "auto",
        maxWidth: card_width,
        width: "auto",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Typography
            style={{
              color: title_color,
              fontSize: fonts.header,
              fontWeight: "bold",
            }}
          >
            {card_title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Typography
            style={{
              color: themes.defaultIcon,
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
            }}
          >
            {card_subtitle}
          </Typography>
        </Grid>
      </Grid>
      <Box className="scrollbar__box">{children}</Box>
    </Box>
  );
};

export default CustomEditCard;
